


























import { defineComponent } from '@vue/composition-api';

export default defineComponent({
	props: {
		checked: {
			type: Boolean,
			required: true,
		},
		value: {
			required: true,
			type: [Number, String, Boolean, Object, Array],
		},
		disabled: Boolean,
	},
});
